<!-- Rebate Request - Measurement Committee / Economic Committee - Accurate Data Form -->
<div *ngIf="!isRequestSucceeded">
    <!-- Form Title -->
    <h2 class="sectionTitle">Accurate Data Form</h2>
    <!-- Rebate Request - Display Mode -->
    <app-rebate-request #rebateRequest (rebateRequestLoadedFlag)="onRebateRequestLoadedFlag($event)">
    </app-rebate-request>
    <form name="accurateDataForm" [formGroup]="accurateDataForm">
        <div class="form-container" #accurateDataFormControls>
            <div class="form-section">
                <h4 class="section-title">Accurate Data Form</h4>
                <!-- Date Of Sailing -->
                <div class="form-group">
                    <label for="txtDateOfSailing">Date of Sailing</label>
                    <input name="DateOfSailing" #dateOfSailingDatepicker="bsDatepicker" bsDatepicker
                        formControlName="DateOfSailing" [minDate]='null'
                        [bsConfig]="{ dateInputFormat: 'DD-MM-YYYY' ,  minMode : hour }" id="dpDateOfSailing"
                        class="form-control">
                </div>
                <div class="form-group">
                  <label for="ddlRateId">Rate</label>

                  <select formControlName="RateId" class="form-control" id="ddlRateId" name="Rate">
                      <option value="" selected>Choose</option>
                      <option *ngFor="let rate of rates" [value]="rate?.Id" >
                          {{rate?.NameEN}}
                      </option>
                  </select>
              </div>
                <!-- Port Of Origin -->
                <div class="form-group">
                    <label for="txtPortOfOrigin">Origin</label>
                    <select formControlName="PortOfOrigin" class="form-control" id="txtPortOfOrigin"
                        name="PortOfOrigin">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let country of countries" [value]="country?.NameEN">
                            {{country?.NameEN}}
                        </option>
                    </select>
                </div>
                <!-- Port Of Destination -->
                <div class="form-group">
                    <label for="txtPortOfDestination">Destination</label>
                    <select formControlName="PortOfDestination" class="form-control" id="txtPortOfDestination"
                        name="PortOfDestination">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let country of countries" [value]="country?.NameEN">
                            {{country?.NameEN}}
                        </option>
                    </select>
                </div>
                <!-- SCNT -->
                <div class="form-group">
                    <label for="txtSCNT">Net Tonnage (SCNT)</label>
                    <input type="text" formControlName="SCNT" name="SCNT" id="txtSCNT" class="form-control" />
                    <div *ngIf="accurateDataForm?.controls['SCNT']?.invalid" class="red">
                        <span *ngIf="accurateDataForm?.controls['SCNT']?.errors?.pattern">Net Tonnage (SCNT) must be (1
                            to 6) digits and allows (1 to 2) Decimals</span>
                    </div>
                </div>
                <!-- Vessel Type -->
                <div class="form-group">
                    <label for="ddlVesselTypeId">Type of Vessel</label>
                    <select formControlName="VesselTypeId" class="form-control" id="ddlVesselTypeId" name="VesselType">
                        <option value="" selected>Choose</option>
                        <option *ngFor="let vesselType of rebateRequest.vesselTypes" [value]="vesselType?.Id">
                            {{vesselType?.NameEN}}
                        </option>
                    </select>
                </div>
                <!-- Kind of Cargo -->
                <div class="form-group">
                    <label for="txtCargo">Kind of Cargo</label>
                    <input type="text" formControlName="Cargo" name="Cargo" id="txtCargo" class="form-control" />
                </div>
                <!-- Other Charges -->
                <div class="form-group">
                    <label for="txtOtherCharges">Extra dues (Other charges) $</label>
                    <input type="text" formControlName="OtherCharges" name="OtherCharges" id="txtOtherCharges"
                        class="form-control" />
                </div>
                <!-- Deadweight -->
                <div class="form-group">
                    <label for="txtDeadweight">Deadweight</label>
                    <input type="text" formControlName="Deadweight" name="Deadweight" id="txtDeadweight"
                        class="form-control" />
                </div>
                <!-- Number of Esc. Tugs -->
                <div class="form-group">
                    <label for="NoOfEscTugs">Number of Esc. Tugs</label>
                    <input type="number" min="0" class="form-control" id="txtNoOfEscTugs" name="NoOfEscTugs"
                        formControlName="NoOfEscTugs"   />
                </div>
                <!-- Number of Imposed Tugs -->
                <div class="form-group">
                    <label for="NoOfImposedTugs">Number of Imposed Tugs</label>
                    <input type="number" min="0" class="form-control" id="txtNoOfImposedTugs" name="NoOfImposedTugs"
                        formControlName="NoOfImposedTugs"   />
                </div>
                <!-- Remarks -->
                <div class="form-group">
                    <label for="txtRemarks">Remarks</label>
                    <textarea type="text" formControlName="Remarks" name="Remarks" id="txtRemarks"
                        class="form-control"></textarea>
                </div>
            </div>
        </div>
        <div class="form-group">
            <button type="button" class="btn SCAcustomBtn" Confirmation (confirmationClick)="submit()">Submit</button>
            <button type="button" class="btn SCAcustomBtn" (click)="later()">Later</button>
        </div>
    </form>
</div>
<!-- Confirmation -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 1" class="alert alert-success" role="alert">
    <div class="alignC">
        <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g>
                <g>
                    <path
                        d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
                    </path>
                </g>
            </g>
        </svg>
        <p>You have submitted Rebate Request - Accurate Data Form Successfully</p>
        <p>Go Back to <a routerLink="/RebateRequest/RequestsManagement">Requests Management</a></p>
    </div>
</div>
<!-- Error -->
<div *ngIf="isRequestSucceeded && submitConfirmationMode == 2" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>Something went wrong, Please contact System Administrator</p>
        <hr>
        <p>Go Back to <a routerLink="/workspace">Workspace</a></p>
    </div>
</div>
